import React, { useState } from "react";
import AmplitudeIcon from "../../../../assets/images/icons/button-icon.svg";
import AmplitudeIconBlue from "../../../../assets/images/icons/amplitude-ai-blue.svg";
import PublicistIcon from '../../../../assets/images/icons/publicist.svg';
import PublicistIconBlue from '../../../../assets/images/icons/publicist-blue.svg';
import MarketingManagerIcon from '../../../../assets/images/icons/marketing-manager.svg';
import GrowthEngineIconBlue from '../../../../assets/images/icons/growth-engine-blue.svg';
import ArtistIcon from '../../../../assets/images/icons/artist.svg';
import ArtistIconBlue from '../../../../assets/images/icons/artist-manager-blue.svg';
import AudioIcon from '../../../../assets/images/icons/audio.svg';
import AudioIconBlue from '../../../../assets/images/icons/audio-engineer-blue.svg';
import CreatorIcon from '../../../../assets/images/icons/creator.svg';
import CreatorIconBlue from '../../../../assets/images/icons/content-creator-blue.svg';
import AnalystIcon from '../../../../assets/images/icons/analyst.svg';
import AnalystIconBlue from '../../../../assets/images/icons/data-analyst-blue.svg';
import ProfessorUIcon from '../../../../assets/images/icons/professor.svg';
import ProfessorUIconBlue from '../../../../assets/images/icons/professoru-blue.svg';
import ResourceIcon from '../../../../assets/images/icons/resource-library.svg'
import MusicLoader from "../../DataAnalyst/sections/components/MusicLoader";
import { Music2Icon, MusicIcon } from "lucide-react";
import { Tooltip } from "../../../../components/Tooltip";
import { useNavigate } from "react-router-dom";
import RewardProgressBar from "./RewardProgressBar";
import { useFetchAllRewards } from "../../../../queries/professoru/forum.query";

function Distinctions({ title, inputPlaceholder, onSend, isDisabled, isCatalog, rewardsButton = true, resourceButton = true, rewardsData: propRewardsData }) {
    const [input, setInput] = useState("");
    const navigate = useNavigate()
    const { data: fetchedRewardsData } = useFetchAllRewards();

    const rewardsData = propRewardsData?.length
        ? propRewardsData
        : (fetchedRewardsData || []);
    const rewardsList = Array.isArray(rewardsData) ? rewardsData : (rewardsData?.data || []);

    const getModuleProgress = (moduleTitle) => {
        const module = rewardsList.find(m => m.moduleTitle === moduleTitle);
        return {
            completed: module?.completedRewards || 0,
            total: module?.totalRewards || 8,
        };
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (input.trim()) {
            onSend(input);
            setInput("");
        }
    };
    return (
        <div
            className={`w-full bg-gradient-to-r from-theme_clr1 to-theme_clr2 rounded-lg sm:rounded-xl lg:rounded-2xl p-3 sm:p-4 md:p-6`}
        >
            <div className="text-white text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 md:mb-4">
                {title}
            </div>
            <form
                onSubmit={handleSubmit}
                className={`flex flex-col ${!isCatalog ? "sm:flex-row sm:items-center" : "sm:flex-col sm:items-start"
                    } gap-2 sm:gap-3 md:gap-4`}
            >
                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder={inputPlaceholder}
                    className="flex-1 bg-transparent border border-white rounded-full px-3 sm:px-4 md:px-6 py-2 md:py-3 text-sm sm:text-base md:text-lg text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 transition-all"
                />
                <button
                    type="submit"
                    disabled={isDisabled}
                    className={`w-full sm:w-auto flex items-center justify-center bg-gradient-to-t from-[#00067e] to-[#3B3B98] hover:from-[#fa6138] hover:to-[#23235b] text-white font-medium text-sm sm:text-base md:text-lg px-4 sm:px-6 md:px-10 py-2 md:py-3 rounded-full transition-all duration-200 shadow-md disabled:opacity-75 ${isCatalog ? "sm:ml-auto sm:mr-0" : ""
                        }`}
                >
                    {isDisabled ? (
                        <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
                            <div className="transform scale-[0.4]">
                                <MusicLoader />
                            </div>
                        </div>
                    ) : (
                        <>
                            <span className="sm:inline">Get Guidance</span>
                            <span className="inline sm:ml-2 md:ml-3">
                                <img src={AmplitudeIcon} alt="Amplitude AI" className="inline-block w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 ml-2 sm:ml-2 md:ml-3" />
                            </span>
                        </>
                    )}
                </button>
            </form>
            <div className="mt-3 sm:mt-4">
                <div className="text-white text-base sm:text-lg md:text-xl font-semibold">
                    Distinctions
                </div>
                <p className="text-gray-300 text-base mb-2"><i>Earn mastery across each module by completing key actions and earning rewards</i></p>
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3 sm:gap-4">
                    <div className="flex flex-wrap gap-1.5 sm:gap-2 items-center">
                        {[
                            {
                                icon: MarketingManagerIcon,
                                tooltipIcon: GrowthEngineIconBlue,
                                moduleName: "Growth Engine",
                                title: `<p>Growth Engine</p>`,
                                text: `<strong classname="text-base font-semibold">Run campaigns and grow your audience</strong>
                                <p>Launch ads, test creatives, and scale what works to earn this distinction.</p>`,
                                alt: "Marketing Manager"
                            },
                            {
                                icon: PublicistIcon,
                                tooltipIcon: PublicistIconBlue,
                                moduleName: "Publicist",
                                title: "Publicist",
                                text: `<strong classname="text-base font-semibold">Get your music in front of the right people</strong>
                                <p>Reach out, pitch effectively, and secure placements and coverage.</p>`,
                                alt: "Publicist"
                            },
                            {
                                icon: ArtistIcon,
                                tooltipIcon: ArtistIconBlue,
                                moduleName: "Artist Manager",
                                title: "Artist Manager",
                                text: `<strong classname="text-base font-semibold">Structure your artist career</strong>
                                <p>Organize releases, manage your profile, and build a clear growth plan.</p>`,
                                alt: "Artist"
                            },
                            {
                                icon: AudioIcon,
                                tooltipIcon: AudioIconBlue,
                                moduleName: "UrStudio",
                                title: "UrStudio",
                                text: `<strong classname="text-base font-semibold">Perfect your sound</strong>
                                <p>Enhance, mix, and master your tracks to reach release-ready quality.</p>`,
                                alt: "Audio"
                            },
                            {
                                icon: CreatorIcon,
                                tooltipIcon: CreatorIconBlue,
                                moduleName: "Content Creator",
                                title: "Content Creator",
                                text: `<strong classname="text-base font-semibold">Build content that converts</strong>
                                <p>Create, refine, and publish content that drives engagement and discovery.</p>`,
                                alt: "Creator"
                            },
                            {
                                icon: AnalystIcon,
                                tooltipIcon: AnalystIconBlue,
                                moduleName: "Data Analyst",
                                title: "Data Analyst",
                                text: `<strong classname="text-base font-semibold">Understand what’s working</strong>
                                <p>Track performance, analyze trends, and use data to guide your growth.</p>`,
                                alt: "Analyst"
                            },
                            {
                                icon: ProfessorUIcon,
                                tooltipIcon: ProfessorUIconBlue,
                                moduleName: "ProfessorU",
                                title: "ProfessorU",
                                text: `<strong>Learn what actually moves your career</strong>
                                <p>Access lessons, guides, and real insights to level up as an artist.</p>`,
                                alt: "ProfessorU"
                            },
                            {
                                icon: AmplitudeIcon,
                                tooltipIcon: AmplitudeIconBlue,
                                moduleName: "Amplitude AI",
                                title: "Amplitude AI",
                                text: `<strong classname="text-base font-semibold">Master your strategy with AI guidance</strong>
                                <p>Use AI insights, follow recommendations, and make smarter decisions.</p>`,
                                alt: "Amplitude AI"
                            },
                        ].map((item, index) => {
                            const { completed, total } = getModuleProgress(item.moduleName);
                            return (
                            <Tooltip
                                icon={item.tooltipIcon}
                                title={item.title}
                                text={item.text}
                                content={<RewardProgressBar completed={completed} total={total} trackClassName="border border-theme_clr1/20" />}
                                key={index}
                                style={{ bg: "bg-white", text: "text-theme_clr1", width: "w-48" }}
                            >
                                <div key={index} className="bg-theme_clr1 border border-white rounded-lg p-2 sm:p-2.5 md:p-3 flex-shrink-0">
                                    <img src={item.icon} alt={item.alt} className="inline-block w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5" />
                                </div>
                            </Tooltip>
                        )})}
                    </div>
                    <div className="flex gap-2 sm:gap-2 md:gap-3 w-full sm:w-auto">
                        {rewardsButton &&
                            <button onClick={() => navigate('/admin/professor-u/rewards')} className="bg-white text-theme_clr1 font-semibold text-sm sm:text-base border border-theme_clr1 rounded-full px-3 sm:px-4 md:px-5 py-1.5 sm:py-2 flex items-center justify-center sm:justify-start gap-2 hover:bg-gray-100 transition-colors flex-1 sm:flex-none">
                                <MusicIcon className="w-3 h-3 sm:w-4 sm:h-4" />
                                <span className="truncate">Rewards</span>
                            </button>
                        }
                        {resourceButton &&
                            <button onClick={() => navigate('/admin/professor-u/resource-library')} className="bg-white text-theme_clr1 font-semibold text-sm sm:text-base border border-theme_clr1 rounded-full px-3 sm:px-4 md:px-5 py-1.5 sm:py-2 flex items-center justify-center sm:justify-start gap-2 hover:bg-gray-100 transition-colors flex-1 sm:flex-none">
                                <img src={ResourceIcon} className="inline-block w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5" />
                                <span className="truncate">Resource Library</span>
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Distinctions;
